<template>
  <div class="d-block">
    <h6 class="m-0 font-weight-bold text-primary">
      UBAH PASSWORD
    </h6>
    <hr>

    <form @submit.prevent="onSubmit">
      <div class="form-group">
        <label>Password Lama</label>
        <input type="password" class="form-control" v-model="form.oldPassword">
      </div>

      <div class="form-group">
        <label>Password Baru</label>
        <input type="password" class="form-control" v-model="form.newPassword">
      </div>

      <div class="form-group">
        <label>Ulangi Password Baru</label>
        <input type="password" class="form-control" v-model="form.confirmPassword">
      </div>

      <div class="row">
        <div class="col">
          <b-button type="submit" variant="primary" block>
            Simpan
          </b-button>
        </div>
      </div>
    </form>

  </div>
</template>

<script>
export default {
  props: ['id'],
  data () {
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    }
  },
  methods: {
    onSubmit () {
      if (this.form.newPassword !== this.form.confirmPassword) {
        this.$bvToast.toast('Password baru dan ulangi password baru tidak cocok', {
          title: 'Gagal!!',
          variant: 'danger',
          solid: true
        })
      } else {
        const formData = new FormData()

        formData.append('oldPassword', this.form.oldPassword)
        formData.append('newPassword', this.form.newPassword)

        this.$axios.post(`/user/change-password/${this.id}`, formData, { headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }}).then(res => {
          this.$bvModal.hide('modalChangePassword')

          this.$bvToast.toast('Berhasil disimpan', {
            title: 'Sukses!!',
            variant: 'success',
            solid: true
          })
        })
      }
    }
  }
}
</script>